// extracted by mini-css-extract-plugin
module.exports = {"container":"ScrollToTop_container__2XGpO","container_hidden":"ScrollToTop_container_hidden__UKc3-","container_text":"ScrollToTop_container_text__1oZUq"};